import { gTagEvent } from './ga';

const setPage = ({ title, description }) => {
  if (title !== document.title) {
    document.title = title;
  }

  const sanitizedDescription = (
    !description
      ? ''
      : description.trim().replace(/\s\s+/g, ' ')
  );

  if (process.env.NODE_ENV === 'development') {
    console.log(`Title: "${title}" (${title.length})`);
    console.log(`Description: "${sanitizedDescription}" (${(sanitizedDescription).length})`);
  }

  const descriptionTag = document.head.querySelector('meta[name="description"]');

  if (sanitizedDescription !== descriptionTag.getAttribute('content')) {
    descriptionTag.setAttribute('content', sanitizedDescription);
  }

  gTagEvent('page_view');
};

export default setPage;